export enum ROUTE {
    LOGIN = 'login',
    EVENTS = 'events',
    CUSTOMERS = 'customers',
    ORDERS = 'orders',
    SALES = 'sales',
    USER = 'user',
}